// extracted by mini-css-extract-plugin
module.exports = {"footer":"styles_footer__2WFGF","content":"styles_content__1wLyi","selectAll":"styles_selectAll__rJzoQ"};